class Offices {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.toggles = self.elem.querySelectorAll('[data-office-content-toggle]');
        self.items = self.elem.querySelectorAll('[data-office-content-item]');
    }

    init() {
        let self = this;

        self.locationToggle();
    }

    locationToggle() {
        let self = this;

        self.toggles.forEach(function (toggle) {
            toggle.addEventListener('click', function() {
                self.toggles.forEach(function (inner) {
                    inner.classList.remove('is-active');
                });

                toggle.classList.add('is-active');

                self.items.forEach(function (item) {
                    item.classList.remove('is-active');

                    if (toggle.dataset.officeContentToggleCount === item.dataset.officeContentItemCount) {
                        item.classList.add('is-active');
                    } else {
                        item.classList.remove('is-active');
                    }
                });
            });
        });
    }
}

export default Offices;
